/**
 * The multi-tenant tabs' loading shapes. Read next to the component each one
 * mirrors.
 */
import {
	CaseSummarySkeleton,
	CaseTableSkeleton,
	CaseToolbarSkeleton,
} from '@/features/air/case-management/components/skeletons'

/**
 * Mirrors `CasesTable`, which renders `CaseListShell`: the toolbar, the
 * chips and count row, then the table body. The route's
 * `pendingComponent` and the tab's `Suspense` fallback both use it, so the two
 * cannot drift (P-05).
 */
export const MultiTenantCasesSkeleton = () => (
	<div className="flex h-full w-full flex-col items-start justify-start gap-6">
		<CaseToolbarSkeleton
			analyticsPrefix="multi_tenant_cases"
			searchPlaceholder="Search cases..."
		/>

		<CaseSummarySkeleton analyticsPrefix="multi_tenant_cases" />

		<CaseTableSkeleton />
	</div>
)
